export function Header() {
  return <header className="header subscreen">Dataverse</header>;
}
